import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as certificate from './CertificateRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({certificate: state.certificate})
const connector = connect(mapState, certificate.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const CertificateInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(CertificateInit)
